  import { Component, Input, NgZone, ElementRef } from '@angular/core';
  import {Http, Headers, Response} from '@angular/http';
  import { Observable } from "rxjs/Observable";
  import 'rxjs/add/operator/map'
  import { FormsModule } from '@angular/forms';
  import { DatePipe } from '@angular/common';
  import { httpService } from '../service/servicio'
  import { ToastsManager } from 'ng2-toastr/ng2-toastr';
  import { ViewContainerRef } from '@angular/core';


@Component({
  selector: 'app-marcas',
  templateUrl: './marcas.component.html',
  styleUrls: ['./marcas.component.css']
})
export class MarcasComponent {

      constructor (private http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

          this.toastr.setRootViewContainerRef(vcr);
           ("en Marcas-..");
          this.tituloMarca = 'Marcas ';
          this.descargarMarcas();
          this.orden(2);

        };


        uploaded = {
          Status:0,
          Text:''

        }

        @Input() marcas: any = [];

        tituloMarca:string =  '';
        marcaSearch: string ='';
        place:string = 'Buscar por Marca';
        sort: string = 'Marca';
        mostrarDatosMarca:boolean = false;

        orden(n) {
          if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
          if (n == 2) { this.sort='marca'; this.place='Buscar por Marca' };
        }

       quitarfiltro(tipo: Number) {
          this.marcaSearch = '';
       }

      filtro() {

          return this.marcas.filter((marca) => {
            if (this.sort == 'Id')
               return marca.Id.toLowerCase().indexOf(this.marcaSearch.toLowerCase()) != -1;
            if (this.sort == 'marca')
               return marca.marca.toLowerCase().indexOf(this.marcaSearch.toLowerCase()) != -1;

           });
      }


      descargarMarcas() {

              this.http.descargarMarcas()
                      .subscribe(marca => {
                           this.marcas = marca;

                      }, err => {

                      }, () => {
                        if (this.marcas == null) {

                            this.toastr.warning("No existen Marcas", "Marcas");

                        }


               });
            }


      pulsado(marca) {
          this.http.marcaGrabar = marca;

          this.mostrarDatosMarca = true;
      }

      crearMarca() {

         this.http.marcaGrabar = this.http.nuevaMarca();


         this.mostrarDatosMarca = true;
      }



      volver() {

        this.http.sw.mostrarMarcas = true;
        this.toastr.warning("Cargando Datos...", "Internet");

      }

      cancelar() {
          this.http.descargarMarcas().subscribe(respuesta => {
          this.marcas = respuesta;
          this.mostrarDatosMarca = false;
        });

      }

      borrarpulsado(marca) {
         ("Borrar pulsado");
        this.http.marcaGrabar = marca;
      }

      borrar(){

          this.http.datosPost.action = 2; // borrar
          this.http.datosPost.datos = this.http.marcaGrabar;
          this.http.marca(this.http.datosPost).subscribe(respuesta => {
                this.http.uploaded = respuesta;

            }, err => {

            }, () => {
                if (this.http.uploaded.Status == 1) {
                      this.toastr.success(this.http.uploaded.Text,'Tarifas');
                      this.http.descargarMarcas().subscribe(respuesta => {
                        this.marcas =respuesta;
                    });
                }else{

                    this.toastr.error(this.http.uploaded.Text,'Tarifas');
                }
          });

      }


      grabar() {
        this.http.datosPost.action = 1; // por defecto Update
        if (this.http.marcaGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
          this.http.datosPost.datos = this.http.marcaGrabar;
          this.http.marca(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;

            }, err => {
               
            }, () => {
              if (this.http.uploaded.Status == 1) {
                  this.toastr.success(this.http.uploaded.Text,'Tarifa');
                  this.http.descargarMarcas().subscribe(respuesta => {
                    this.marcas = respuesta;
                    this.mostrarDatosMarca = false;
                  });
              }else{
                  this.toastr.error(this.http.uploaded.Text,'Tarifa');
              }
        });

      }


}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/marcas/marcas.component.ts